import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import "react-toastify/dist/ReactToastify.css";

// Define the initial state
const initialState = {
  data: [],
  loading: false,
  error: null,
  unreadMessagesCount: 0 
};

// Define a thunk for fetching data asynchronously
export const fetchData = createAsyncThunk('api/fetchData', async (body) => {  

  try {
    var headers = body.headers
    var apiurl = body.apiurl
    var method = body.method
    delete body.headers
    delete body.apiurl
    delete body.method
    if(method === 'post'){
      const response = await axios.post(process.env.REACT_APP_API_URL+apiurl, body, {headers: headers});
      return response.data;
    }
    else if(method === 'put'){
      const response = await axios.put(process.env.REACT_APP_API_URL+apiurl, body, {headers: headers});
      return response.data;
    }
    else{
      const response = await axios.get(process.env.REACT_APP_API_URL+apiurl, {headers: headers});
      return response.data;
    }
  } catch (error) {
    console.log('error')
    console.log(error.response.data.message === 'Token expired or invalid token provided!')
    localStorage.clear();
    if(error.response.data.status === 500 && error.response.data.message == 'Token expired or invalid token provided!'){
      localStorage.clear();
      window.location.reload();
      console.log("Logout")
      console.log(error.response.data)
    }
    return error
  }
});

// Define the slice
const apiSlice = createSlice({
  name: 'api',
  initialState,
  reducers: {
    // Add these new reducers for message count management
    setUnreadMessagesCount: (state, action) => {
      
      state.unreadMessagesCount = action.payload;
    },
    incrementUnreadCount: (state) => {
      state.unreadMessagesCount += 1;
    },
    decrementUnreadCount: (state) => {
      if (state.unreadMessagesCount > 0) {
        state.unreadMessagesCount -= 1;
      }
    },
    resetUnreadCount: (state) => {
      state.unreadMessagesCount = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

// Export the actions
export const { 
  setUnreadMessagesCount,
  incrementUnreadCount,
  decrementUnreadCount,
  resetUnreadCount
} = apiSlice.actions;

export default apiSlice.reducer;